import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { Typography, Upload } from "antd";
import { DocumentUploadIcon } from "../../custom";

const { Dragger: AntdDragger } = Upload;

const props = {
    name: PropTypes.string,
    multiple: PropTypes.bool,
    files: PropTypes.array,
    accept: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

const Dragger = ({ name, multiple, files, accept, onChange }) => {
    const { t } = useTranslation();

    const { theme } = useSelector((state) => state.theme);

    return (
        <AntdDragger
            {...{
                name: name || null,
                multiple: multiple,
                itemRender: null,
                showUploadList: false,
                fileList: files,
                accept: accept,
                beforeUpload: () => false,
                onChange: onChange,
            }}
        >
            <Typography.Paragraph className="ant-upload-drag-icon">
                <DocumentUploadIcon theme={theme} width={90} />
            </Typography.Paragraph>
            <Typography.Paragraph className="ant-upload-hint">
                <span
                    dangerouslySetInnerHTML={{
                        __html: t("selectFileDescription", {
                            fileTypes: accept,
                        }),
                    }}
                />
            </Typography.Paragraph>
        </AntdDragger>
    );
};

Dragger.propTypes = props;

export default Dragger;
